import { useTranslation } from 'react-i18next'
import { classNames } from 'ui/utilities'
import { FC } from 'react'

interface Props {
  label?: string | null
  secondary?: boolean
  value: boolean
}

export const EnabledIndicator: FC<Props> = ({ value, label = null, secondary = false }) => {
  const { t } = useTranslation()

  return (
    <div className="grow inline-flex items-center justify-self-start space-x-2">
      <span className="flex h-3 w-3 relative">
        <span
          className={classNames(
            'animate-ping absolute inline-flex h-full w-full rounded-full opacity-75',
            value ? 'bg-green-400' : 'bg-red-400'
          )}
        ></span>
        <span
          className={classNames(
            'relative inline-flex rounded-full h-3 w-3',
            value ? 'bg-green-500' : 'bg-red-500'
          )}
        ></span>
      </span>
      <span className={`text-sm ${secondary ? 'text-gray-500' : 'text-gray-800 font-medium'}`}>
        {label === null
          ? value
            ? t('enabled_indicator.enabled')
            : t('enabled_indicator.disabled')
          : ''}
        {label !== null && label}
      </span>
    </div>
  )
}
